'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = shouldFetch;
var PROPS = ['path', 'value', 'after', 'fetch', 'fetchLinks', 'orderings', 'page', 'pageSize'];

function shouldFetch(prevProps, currentProps) {
  return PROPS.some(function (prop) {
    return prevProps[prop] !== currentProps[prop];
  });
}